import { Step } from "react-joyride";

export const tourStepsCredits = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "Credits lists people and resources that helped make Race The Clock.",
      disableBeacon: true,
    },
    {
      target: ".max-w-2xl",
      content:
        "The links go to Bunny on a Cloud, which provided fonts and clipart. The names at the bottom are the site creators.",
    },
  ];

  return steps;
};
